import './styles.scss';
import React from "react";
import {useNavigate} from "react-router-dom";
import {NavigateFunction} from "react-router/dist/lib/hooks";
import Utils from "../../utils";
import {Button} from "react-bootstrap";

interface IProps  {
  label: string;
  clickFunc?: any;
  link?: string;
  linkArrow?: boolean;
  linkArrowReverse?: boolean;
  linkUpDownArrow?:string;
  underline?: boolean;
  disabled?:boolean;
}

const LinkButton = (props: IProps):JSX.Element => {
  const {
    clickFunc,
    label,
    linkArrow,
    linkArrowReverse,
    underline,
    disabled,
    linkUpDownArrow
  } = props;

  const link:string = (props.link?.substring(0,3) === 'www.') ? Utils.addProtocol(props.link) : props.link;
  const navigate:NavigateFunction = useNavigate();

  const handleClick = ()=>{
    if (disabled) return;

    if ( clickFunc) {
      clickFunc()
    } else if (link) {
      if (link.indexOf('http') !== -1 ) {
        // external
        window.location.href = link;
      } else {
        // internal
        navigate(link);
      }
    }
  }

  return (
    <Button
      disabled = {disabled}
      className={'link-btn btn py-1 rounded bg-transparent border-0' + (disabled ? ' disabled': '')}
      onClick={(e) => {
        handleClick()
      }}
    >
      {linkArrowReverse &&
        <span className={'long-arrow-left text-link-color'}/>}
        <span className={'label text-link-color text-normal' + (underline ? ' link' : '' )} dangerouslySetInnerHTML={{__html: label}}></span>

      {linkUpDownArrow &&
        <span className={'ms-1 d-inline-block'}>
          <i className={`bi bi-chevron-${linkUpDownArrow} text-link-color`}/>
        </span>}

      {linkArrow &&
        <span className={'long-arrow-right'}/>}
    </Button>
  )
}

export default LinkButton;
